import { CoSellerModelIcon, SubstitutionModelIcon } from "assests/GmsIcons";
import React, { useState } from "react";

interface ModelIconProps {
  type: "Co-seller" | "Substitution";
  isExternal?: boolean | null;
}

const ModelIcon: React.FC<ModelIconProps> = ({
  type, isExternal
}) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  return (
    <div
      className="tw-relative tw-inline-block"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      aria-label={type}
    >
      <div>
        {type === "Co-seller" ? (
          <CoSellerModelIcon />
        ) : type === "Substitution" ? (
          <SubstitutionModelIcon />
        ) : null}
      </div>

      {showTooltip && (
        <div className="tw-absolute tw-z-10 tw-top-full tw-left-1/2 tw-transform tw--translate-x-1/2 tw-mt-1" role="tooltip">
          <div className="tw-h-[25px] tw-px-2 tw-py-1 tw-bg-white tw-rounded-sm tw-shadow-[0px_4px_6px_0px_rgba(9,30,66,0.24)] tw-border tw-justify-center tw-items-center tw-gap-1.5 tw-inline-flex">
            <div className="tw-text-[#172b4d] tw-text-xs tw-font-normal tw-font-['Noto Sans'] tw-leading-none">
              {isExternal ? `${type} (External)` : type}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModelIcon;